<template lang="pug">
  v-layout.option-item(column)
    PortionCountDialog(v-if="showPortionCountDialog && isPortion"
      :showPortionCountDialog="showPortionCountDialog"
      @save="save"
      @close="closePortionCountDialog"
      :searchTerm="searchTerm ? searchTerm : selectedFoodItem ? selectedFoodItem.name : null"
      :portionsCount="portionsCount")
    FoodDialog(v-if="showFoodDialog" :showFoodDialog="showFoodDialog"
      :tagCollection="tagCollection" :subGroupTags="subGroupTags" :currentFoodItem="currentFoodItem"
      :searchTerm="searchTerm" :itemCollection="itemCollection" :allergensList="allergensList"
      :isSelectionTagReadOnly="true"
      @closeDialog="closeFoodDialog")
    v-snackbar( v-model="snackbar" :timeout="snackbarTimeout" :color="snackbarColor" ) {{snackBarText}}
      template( v-slot:action="{attrs}")
        v-btn(text v-bind="attrs"
          @click="snackbar = false")
          v-icon fal fa-times


    v-row.rowClass
      div.menu_code.pa-1 {{indexMenu}}
      v-autocomplete.search(
        flat
        v-model="model"
        :items="entries"
        :search-input.sync="searchTerm"
        :filter="customFilter"
        @change="openDialog"
        hide-details
        hide-selected

        item-text="name"
        item-value="id"
        :append-icon="iconMenu"
        filled
        return-object
        :loading="saveInProgress || fetchInProgress"
      )
        template(v-slot:no-data)
          v-list-item
            v-list-item-content {{emptyEntriesText}}
        template(v-slot:prepend-item)
          v-list-item(ripple @mousedown.prevent @click="openFoodDialogClick" )
            v-list-item-content.primary--text
              v-list-item-title {{ $t('dailymenuPage.addFoodButtonLabel') }}
          v-divider.mt-1
    v-row.ma-0.mb-0(v-if="isPortion && this.$vuetify.breakpoint.mdAndUp" justify="end" )
      v-col.align-self-center.pa-0.col-auto
        span.subtitle-2 {{ $t('orderPage.portionCount') }}:
      v-col.mt-1.col-auto
        div.pa-0.ma-0.text-end.elevation-0.pt-4.subtitle-2.justify-end.align-content-end.align-center.pb-4(class="some-style" readonly ) {{portionsCount}}
      v-col.align-self-center.ma-0.col-auto.pa-1.py-0( justify="start" )
        v-btn(:disabled="!searchTerm" @click="openDetailDialog" medium)
          v-icon fas fa-pen
    v-row.ma-0.mb-0(v-if="isPortion && this.$vuetify.breakpoint.smAndDown" justify="end" )
      v-col.align-self-center.pa-0.col-auto
        span.subtitle-2 {{ $t('orderPage.portionCount') }}:
      v-col.col-auto.mt-1
        div.pa-0.ma-0.subtitle-2(readonly ) {{portionsCount}}
      v-col.align-self-center.col-auto.py-0.pa-1
        v-btn.pa-0(@click="openDetailDialog" small)
          v-icon fas fa-pen


</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash'
import DailyMenuOption from '@/model/dailymenu/DailyMenuOption'
import {
  FETCH_FOOD_ITEM_DETAILS,
  SAVE_FODD_TO_DAILYMENU,
  SEARCH_FOOD_ITEM
} from '@/store/action-types'
import {DAILY_MENU_OFFER_TEMPLATE} from '@/store/getter-types'
import {Component, Prop, Watch} from "vue-property-decorator";
import {FoodMenuOfferPayload} from "@/types/payload";
import FoodDialog from "@/components/dailymenu/FoodDialog.vue";
import FoodItem from "@/model/food-database/FoodItem";
import Tag from "@/model/tennant/Tag";
import {Action} from "vuex-class";
import Allergen from "@/model/food-database/Allergen";
import KeyList from "@/model/KeyList";
import PortionCountDialog from "@/components/dailymenu/detail/PortionCountDialog.vue";
import {useDailyMenuOfferStore} from '@/store/dailyMenuOfferStore'


@Component({
  components: {
    FoodDialog,
    PortionCountDialog
  }
})

export default class OfferListItemOption extends Vue {

  @Prop({type: Object as () => DailyMenuOption}) item!: DailyMenuOption
  @Prop({type: Array as () => KeyList[]}) keyList!: KeyList[]
  @Prop({type: Array as () => Tag[]}) tagCollection!: Tag[]
  @Prop({type: Array as () => Tag[]}) subGroupTags!: Tag[]
  @Prop({type: Array as () => FoodItem[]}) itemCollection!: FoodItem[]
  @Prop({type: Array as () => Allergen[]}) allergensList!: Allergen[]
  @Action(FETCH_FOOD_ITEM_DETAILS) fetchFoodItemDetails!: { (payload: number): Promise<FoodItem> }

  private dailyMenuOfferStore = useDailyMenuOfferStore()

  private model: any = null
  private fetchInProgress: boolean = false
  private selectedItem: any = null
  private entries: any = []
  private snackbar: boolean = false
  private snackBarText: string = ''
  private snackbarTimeout: number = 5000
  private snackbarColor: string = ''
  private searchTerm: string | null = null
  private descriptionLimit: number = 60
  private lastSelectedDate: string = ""

  private showFoodDialog: boolean = false
  private currentFoodItem: FoodItem | null = null
  private saveInProgress: boolean = false
  private isTrue: boolean = false
  private portionsCount: string = '-'
  private showPortionCountDialog: boolean = false
  private selectedFoodItem: FoodItem | null = null
  private id: string | null = null
  private data: any | null = null
  private updatedData : any | null = null


  get fields() {
    if (!this.model) return []

    // @ts-ignore
    return Object.keys(this.model).map(key => {
      return {
        key,
        // @ts-ignore
        value: this.model[key] || 'n/a',
      }
    })
  }

  get items() {
    // @ts-ignore: Unreachable code error
    return this.entries.map(entry => {
      const name = entry.name.length > this.descriptionLimit
          ? entry.name.slice(0, this.descriptionLimit) + '...'
          : entry.name

      return Object.assign({}, entry, {name})
    })
  }

  get selectedDate(): string {
    return this.$store.getters[DAILY_MENU_OFFER_TEMPLATE]
  }

  get indexMenu(): string {
    // @ts-ignore: Unreachable code error
    return this.item ? this.item.code : ''
  }

  get iconMenu(): string {
    // @ts-ignore: Unreachable code error
    return !this.selectedItem ? 'fas fa-search' : 'fas fa-check foodFilled'
  }

  get isFoodInMenu(): boolean {
    return this.currentFoodItem?.name !== ""
  }

  get emptyEntriesText(): string {
    if (this.searchTerm === null || this.searchTerm!.length < 3) {
      return this.$t('dailymenuPage.enterFoodNameText').toString()
    }else if(this.selectedItem && this.entries.length > 0){
      return this.selectedItem.name
    }else{
        return this.$t('dailymenuPage.foodWithThatNameDoesntExistText').toString()
      }
    }

  get isPortion (): boolean {
   if(this.keyList) {
     const foundItem: KeyList | undefined = this.keyList.find((item: KeyList) => item.key === 'tenant.allow_portions_count' && item.value === 'true')
     if(foundItem){
       return true
     } else{
       return false
     }
   } else {
     return false
   }
  }

  @Watch('item')
  watchItem(newVal: any) {
    this.entries = []
    this.model = null
    this.selectedItem = null

    if (newVal.offer && newVal.offer.foodItem) {
      this.model = newVal.offer.foodItem
      this.selectedItem = newVal.offer.foodItem
      this.entries.push(this.selectedItem)
    }
  }

  @Watch('searchTerm')
  watchSearchTerm(newVal: string | undefined) {

    if (newVal && newVal.length >= 3) {
      this.startSearch(newVal)
    }
  }

  @Watch('selectedDate')
  watchSelectedDate(newVal: any): void {
    if(newVal) {
      this.lastSelectedDate = newVal.date
      this.portionsCount = this.item && this.item.offer && this.item.offer!.portionsCount ? this.item.offer!.portionsCount.toString() : '-'
    }
  }

  @Watch('data')
  watchData(newVal: any): void {
    if(newVal) {
      this.id = this.data.id
    }
  }

  @Watch('updatedData')
  watchUpdatedData(newVal: any): void {
    if(newVal) {
      this.id = newVal.id
      this.portionsCount = newVal.portionsCount
    }
  }

  closePortionCountDialog (){
    this.portionsCount = ''
    this.dataChanged(this.selectedFoodItem!)
    this.showPortionCountDialog = false
  }

  openFoodDialogClick(): void {

    if (this.isFoodInMenu && this.selectedItem !== null) {
      this.currentFoodItem = FoodItem.createEmptyWithName(this.selectedItem.name)
      this.showFoodDialog = true

    } else {
      this.currentFoodItem = FoodItem.createEmpty()
      this.showFoodDialog = true

      if (this.$refs['foodForm']) {
        //@ts-ignore
        this.$refs['foodForm'].resetValidation()
      }
    }
  }

  closeFoodDialog(foodItem: FoodItem | null): void {
    if (!foodItem) {
      this.snackbarColor = "error"
      this.snackBarText = this.$t('foodDatabasePage.foodItemSaveErrorMessage').toString()
      this.snackbar = true
    }

    this.currentFoodItem = null
    this.showFoodDialog = false

    if (foodItem !== null) {
      this.selectedFoodItem = foodItem
      if(this.isPortion) {
        this.showPortionCountDialog = true
      } else {
        this.dataChanged(this.selectedFoodItem!)
      }
    }
  }

  startSearch(searchTerm: string): void {
    this.searchFood(searchTerm)
  }

  customFilter(item: any, queryText: any): any {
    const textOne = item.name.toLowerCase()
    const searchText = queryText.toLowerCase()

    return textOne.indexOf(searchText) > -1
  }

  openDetailDialog() {
    this.showPortionCountDialog = true
    this.selectedFoodItem = this.selectedItem
  }

  openDialog (item: any) {
    if(this.isPortion) {
      this.showPortionCountDialog = true
      this.selectedFoodItem = item
    } else {
      this.dataChanged(item)
    }
  }

  save(portion: any){
    this.portionsCount = portion
    this.dataChanged(this.selectedFoodItem!)
  }

  async dataChanged(item: FoodItem): Promise<void> {

    this.saveInProgress = true

    let typeRequest = this.selectedItem ? 'PUT' : 'POST'
    this.selectedItem = item
    if(this.data) {
      let payload: FoodMenuOfferPayload = {
        type: typeRequest,
        id: this.data ? this.id : null,
        foodItem: {
          referenceFoodItem: item.id,
          menuGroupSlot: this.item.id,
          date: this.lastSelectedDate,
          business: this.dailyMenuOfferStore.selectedBusiness!.id,
          portionsCount: this.portionsCount ? parseInt(this.portionsCount) : null
        }
      }
      try {
        this.data = await this.$store.dispatch(SAVE_FODD_TO_DAILYMENU, payload)
        this.showPortionCountDialog = false
        this.$emit('update')
        this.lastSelectedDate = this.$route.params.date

        this.id = this.data.id
        this.model = this.selectedItem
        this.entries.push(this.selectedItem)
        this.currentFoodItem = this.selectedItem
        this.portionsCount = this.data && this.data.portionsCount ? this.data.portionsCount : '-'
      } catch {
        this.snackbar = true
        this.snackbarColor = 'error'
        this.snackBarText = this.$t('dailymenuPage.foodNotSaved').toString()
      } finally {

        this.snackbar = true
        this.snackbarColor = 'success'
        this.snackBarText = this.$t('dailymenuPage.foodSaved').toString()
      }
      this.saveInProgress = false
    } else {
      let payload: FoodMenuOfferPayload = {
        type: typeRequest,
        id: this.item.offer ? this.item.offer.id : null,
        foodItem: {
          referenceFoodItem: item.id,
          menuGroupSlot: this.item.id,
          date: this.lastSelectedDate,
          business: this.dailyMenuOfferStore.selectedBusiness!.id,
          portionsCount: this.portionsCount ? parseInt(this.portionsCount) : null
        }
      }
      try {
        this. updatedData = await this.$store.dispatch(SAVE_FODD_TO_DAILYMENU, payload)
        this.showPortionCountDialog = false
        this.$emit('update',this.selectedDate)
        this.model = this.selectedItem
        this.entries.push(this.selectedItem)
        this.currentFoodItem = this.selectedItem
        this.portionsCount = this.item.offer && this.item.offer.portionsCount ? this.updatedData.portionsCount.toString() : '-'

      } catch {
        this.snackbar = true
        this.snackbarColor = 'error'
        this.snackBarText = this.$t('dailymenuPage.foodNotSaved').toString()
      } finally {
        this.snackbar = true
        this.snackbarColor = 'success'
        this.snackBarText = this.$t('dailymenuPage.foodSaved').toString()
      }

      this.saveInProgress = false
    }
  }

  async searchFood(searchText: string): Promise<void> {
    const slotId = parseInt(this.item.id)

    try {
      this.fetchInProgress=true

      this.entries = await this.$store.dispatch(SEARCH_FOOD_ITEM, {slot: slotId, searchText: searchText})
      this.fetchInProgress=false
    } catch {
      this.snackbar = true
      this.snackbarColor = 'error'
      this.snackBarText = this.$t('dailymenuPage.errorSearch').toString()
    }
  }

  created() {
    const origSearch = this.startSearch

    this.startSearch = _.debounce((searchTerm: string) => {
      origSearch(searchTerm)
    }, 250)
  }

  async foodItemDetails(foodItemId: number): Promise<void> {
    try {
      this.currentFoodItem = await this.fetchFoodItemDetails(foodItemId)
    } catch (e) {
      this.snackbar = true
      this.snackbarColor = 'error'
      this.snackBarText = this.$t('dailymenuPage.fetchFoodDetailsErrorText').toString()
    }
  }

  mounted(): void {
    this.entries = []
    this.model = null
    // @ts-ignore: Unreachable code error
    if (this.item) {
      // @ts-ignore: Unreachable code error
      if (this.item.offer) {
        this.foodItemDetails(this.item.offer.foodItem.id)
        this.model = this.item.offer.foodItem
        this.selectedItem = this.item.offer.foodItem
        this.entries.push(this.selectedItem)
        this.portionsCount = this.item.offer && this.item.offer.portionsCount ? this.item.offer.portionsCount.toString() : '-'
      }
    }
    this.lastSelectedDate = this.$route.params.date
  }
}
</script>

<style lang="stylus">

.foodFilled
  color #4caf50 !important

</style>

<style lang="stylus" scoped>

.some-style >>> .v-input__slot::before {
  border-style: none !important;
}

.option-item
  margin 10px

  .rowClass
    align-items center
    padding 0 10px
    flex-wrap nowrap

  .menu_code
    max-width 40px
    font-size 2em
    text-align center
    align-items center
    justify-content center
    display flex
    color: gray

  .search
    max-width 100%
    padding 5px

  .notfilled
    border 1px dotted #e1e1e1
.noData
  max-width 100%
  font-size 18px
  padding 8px

</style>
